<template>
    <div class="body d-flex py-lg-3 py-md-2 mb-5">
        <div class="container-xxl">
            <h1 class="fw-bold page-title d-none">Συχνές Ερωτήσεις (FAQ)</h1>
            <div class="row clearfix">
                <div class="px-3">
                    <div class="row text-center gap-2">
                        <div class="col">
                            <div class="accordion" id="accordionExample">
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            1. Τι κάνω αν ξέχασα τον κωδικό πρόσβασης;
                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Μπορείτε να επαναφέρετε τον κωδικό σας πατώντας στην επιλογή “Ξέχασα τον κωδικό μου” στη σελίδα σύνδεσης. Θα λάβετε σχετικό email με οδηγίες επαναφοράς. 
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            2. Μπορώ να αλλάξω τον κωδικό πρόσβασής μου;
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Φυσικά! Πατώντας αριστερά στο μενού "Αλλαγή κωδικού".
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                            3. Πώς μπορώ να επεξεργαστώ τα στοιχεία της επιχείρησής μου μετά την καταχώρηση;
                                        </button>
                                    </h2>
                                    <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Μπορείτε να επεξεργαστείτε τα στοιχεία της επιχείρησής σας μέσα από τον λογαριασμό σας, επιλέγοντας “Επεξεργασία Προφίλ” στο μενού διαχείρισης.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                                            4. Μπορεί να εγγραφεί οποιαδήποτε επιχείρηση στην πλατφόρμα και ανεξάρτητα από το Επιμελητήριο το οποίο ανήκει;
                                        </button>
                                    </h2>
                                    <div id="collapse4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Η εγγραφή μιας επιχείρησης στο My City Market δεν εξαρτάται από το Επιμελητήριο στο οποίο είναι εγγεγραμμένη. Απαραίτητη προϋπόθεση είναι η έδρα της επιχείρησης να βρίσκεται εντός των ορίων του Δήμου. Η επαλήθευση πραγματοποιείται μέσω του ΑΦΜ, από τον αρμόδιο χειριστή του Δήμου, ο οποίος είναι υπεύθυνος για τον έλεγχο και την έγκριση των επιχειρήσεων που προβάλλονται στην πλατφόρμα.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                                            5. Μπορώ να προσθέσω Social Media της επιχείρησής μου;
                                        </button>
                                    </h2>
                                    <div id="collapse5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Ναι, στο προφίλ της επιχείρησής σας μπορείτε να καταχωρήσετε τους συνδέσμους των social media σας (Facebook, Instagram, κ.ά.), ώστε οι χρήστες να σας ακολουθούν ή να επικοινωνούν εύκολα μαζί σας.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                                            6. Τι είδους αρχεία μπορώ να ανεβάσω στο προφίλ της επιχείρησής μου;
                                        </button>
                                    </h2>
                                    <div id="collapse6" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Μπορείτε να ανεβάσετε φωτογραφίες (π.χ. λογότυπο, εξωτερικό/εσωτερικό καταστήματος, προϊόντα ή υπηρεσίες), σε μορφή JPG ή PNG.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                                            7. Μπορώ να επιλέξω περισσότερες από μία κατηγορίες για την επιχείρησή μου;
                                        </button>
                                    </h2>
                                    <div id="collapse7" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Ναι, μπορείτε να επιλέξετε πάνω από μία κατηγορία για την επιχείρησή σας, ώστε να την περιγράψετε με τον πιο ολοκληρωμένο και αντιπροσωπευτικό τρόπο.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                                            8. Τι μπορώ να κάνω αν δεν υπάρχει διαθέσιμη κατηγορία για την επιχείρησή μου;
                                        </button>
                                    </h2>
                                    <div id="collapse8" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Αν δεν υπάρχει κατάλληλη κατηγορία για την επιχείρησή σας, μπορείτε προσωρινά να την καταχωρήσετε στην επιλογή "Άλλες Υπηρεσίες". Εναλλακτικά, μπορείτε να επικοινωνήσετε με τον δήμο ώστε να εξεταστεί η δυνατότητα δημιουργίας νέας, πιο κατάλληλης κατηγορίας.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                                            9. Μπορώ να προσθέσω προσφορές για την επιχείρησή μου στην πλατφόρμα;
                                        </button>
                                    </h2>
                                    <div id="collapse9" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Ναι, μπορείτε να προσθέσετε προσφορές ώστε να προβάλλετε ειδικές τιμές ή πακέτα υπηρεσιών της επιχείρησής σας και να προσελκύσετε περισσότερους πελάτες μέσω της πλατφόρμας.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse10">
                                            10. Μπορώ να ορίσω πότε θα ξεκινά και πότε θα λήγει μια προσφορά;
                                        </button>
                                    </h2>
                                    <div id="collapse10" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Ναι, μπορείτε να προγραμματίσετε την ημερομηνία έναρξης και λήξης κάθε προσφοράς, ώστε να ενεργοποιείται και να απενεργοποιείται αυτόματα σύμφωνα με το χρονοδιάγραμμα που έχετε ορίσει.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'vue-toastification/dist/index.css';

export default {
    metaInfo: {
        title: 'Συχνές Ερωτήσεις (FAQ)',
        meta: [
            { name: 'description', content: 'Συχνές Ερωτήσεις (FAQ)' },
            { property: 'og:title', content: 'Συχνές Ερωτήσεις (FAQ)' },
            { property: 'og:description', content: 'Συχνές Ερωτήσεις (FAQ)' }
        ]
    }
};
</script>

<style scoped>
    .accordion{
        --bs-accordion-border-width: 0px;
    }
    .accordion-item{
        margin: 20px 0px;
        box-shadow: 0px 0px 10px 0px #dedede;
    }
    
    .accordion-body{
        box-shadow: inset 0px -10px 15px -20px;
        font-size: 16px;
    }
    .accordion-button{
        color: var(--primary-color);
        border-bottom: 0px;
    }
    .accordion-button:not(.collapsed){
        background-color: unset;
        color: var(--primary-color);
        font-weight: bold;
        border-bottom: 1px solid var(--primary-color)
    }
    .accordion-button::after{
        color: var(--primary-color);
    }
    .accordion-button:focus{
        background-color: unset;
        color: var(--primary-color);
        font-weight: bold;
        border-bottom: 1px solid var(--primary-color);
        box-shadow: none !important;
    }
    .accordion-item:last-of-type .accordion-button.collapsed{
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 0px;
    }
</style>
